import React from 'react';
import { StyledTag } from './styles/StatusTag.styles';

interface StatusTagProps {
  status: string;
}

const statusConfig: Record<string, { color: string; text: string }> = {
  // Верхний регистр
  DRAFT: { color: '#d9d9d9', text: 'Черновик' },
  PUBLISHED: { color: '#1890ff', text: 'Опубликован' },
  IN_PROGRESS: { color: '#52c41a', text: 'В процессе' },
  COMPLETED: { color: '#722ed1', text: 'Завершен' },
  CANCELLED: { color: '#ff4d4f', text: 'Отменен' },
  DELETED: { color: '#ff4d4f', text: 'Удален' },

  // Нижний регистр
  draft: { color: '#d9d9d9', text: 'Черновик' },
  published: { color: '#1890ff', text: 'Опубликован' },
  in_progress: { color: '#52c41a', text: 'В процессе' },
  completed: { color: '#722ed1', text: 'Завершен' },
  deleted: { color: '#ff4d4f', text: 'Удален' },
};

export const StatusTag: React.FC<StatusTagProps> = ({ status }) => {
  const config = statusConfig[status] || { color: '#d9d9d9', text: status };

  return (
    <StyledTag color={config.color}>
      {config.text}
    </StyledTag>
  );
};